import React, { useState } from "react"
import Image from "gatsby-plugin-sanity-image"

import { motion, AnimatePresence } from "framer-motion"
import { wrap } from "@popmotion/popcorn"

const GalleryItem = ({ image, ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      {...props}
    >
      {image && image.asset && <Image {...image} className="w-full" />}
    </motion.div>
  )
}

export const ImageGallery = ({ items }) => {
  const [pageIndex, setPageIndex] = useState(0)
  const wrappedIndex = wrap(0, items.length, pageIndex)

  return (
    <div className="w-full">
      {items.length && (
        <AnimatePresence exitBeforeEnter>
          <GalleryItem
            {...items[wrappedIndex]}
            key={pageIndex}
            drag="x"
            dragMomentum={false}
            dragElastic={false}
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={(e, { offset, velocity }) => {
              if (offset.x > 100) {
                setPageIndex(pageIndex - 1)
              } else if (offset.x < -100) {
                setPageIndex(pageIndex + 1)
              }
            }}
          />
        </AnimatePresence>
      )}
      {items.length > 1 && (
        <nav className="flex justify-center my-4">
          {items.map((item, index) => (
            <button
              onClick={() => setPageIndex(index)}
              className={`rounded-full bg-black h-3 w-3 mx-1 focus:outline-none ${
                pageIndex === index ? "opacity-100" : "opacity-40"
              }`}
            />
          ))}
        </nav>
      )}
    </div>
  )
}
